import {
  basicStyle,
  parallaxStyle,
  overlayStyles as overlayBg,
  imageAndContentHeight,
  onlyImageHeight,
} from './styles'

const getBgImage = ({ isMobile, isTablet, background }) => {
  let property = 'bg_image'

  if (isMobile) {
    property = 'bg_image_mobile'
  } else if (isTablet) {
    property = 'bg_image_tablet'
  } else {
    property = 'bg_image'
  }

  const imageUrl = background[property]?.url

  return `url('${imageUrl}')`
}

export const getProperties = ({ data, isMobile, isTablet }) => {
  const parallax = data?.background?.parallax
  const applyOverlay = data?.background?.apply_overlay

  const imageWithContent = data?.content?.image_with_content
  const title = data?.content?.title
  const description = data?.content?.description
  const label = data?.content?.label

  const bgImage = getBgImage({ isMobile, isTablet, background: data?.background })

  const styleToUse = parallax ? parallaxStyle : basicStyle

  const heightToUse = imageWithContent ? imageAndContentHeight : onlyImageHeight

  const containerStyles = `${heightToUse} ${styleToUse}`

  const overlayStyles = applyOverlay ? overlayBg : {}

  const backgroundStyle = {
    backgroundImage: `${bgImage}`,
  }

  const overlayClass = `w-full ${heightToUse}`

  return {
    containerStyles,
    backgroundStyle,
    imageWithContent,
    label,
    title,
    description,
    overlayStyles,
    overlayClass,
  }
}
